import { useRefundLineItems } from "./use-refund-line-items-context.tsx";
import useLineItemsState from "./use-line-items-state-context.tsx";

export function useRefundLineItemsContainARefund() {
  const { items: draftLineItems } = useRefundLineItems();
  const { lineItemsState } = useLineItemsState();
  return draftLineItems.some((lineItem) => {
    const itemState = lineItemsState[lineItem.line_item_id];
    return (
      lineItem.resolution === "refund" && itemState.total.selectedQuantity > 0
    );
  });
}
